var _rect, _g, _rect2, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSortIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1861_27238",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 2,
    width: 12,
    height: 13
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 2.5,
    width: 12,
    height: 12,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1861_27238)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 4.5H14.5V10.5L17.25 7.75L17.96 8.46L14 12.42L10.04 8.46L10.75 7.75L13.5 10.5V4.5V4.5Z",
    fill: "#8A99A1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1861_27238",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 13
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 12,
    height: 12,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1861_27238)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.50004 10.5001H5.50004V4.50008L2.75004 7.25008L2.04004 6.54008L6.00004 2.58008L9.96004 6.54008L9.25004 7.25008L6.50004 4.50008V10.5001V10.5001Z",
    fill: "#8A99A1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/sortIcon.159ce44e.svg";
export { ForwardRef as ReactComponent };